<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="wcrd_bus_own_priv_lic"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >REGISTRATION FORMS
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <v-card-title>
            <h6>
              Disclaimer: Forms that are damaged, bent, or have folded corners
              will not be accepted as this will be rejected by the scanner.
            </h6>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-column justify-start align-start ml-8">
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/EX%20FELON%20REG%20FORM%20081513.pdf"
                target="_blank"
                >EX FELON REGISTRATION FORM</a
              >
              <!-- <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/SEX%20OFF%20INITIAL%20REG%20FORM%20012220.pdf"
                target="_blank"
                >SEXUAL OFFENDER INITIAL REG FORM</a 
              > -->
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/SEX%20OFF%20INITIAL%20REG%20FORM%20012220.pdf"
                target="_blank"
                >SEXUAL OFFENDER INITIAL REG FORM</a
              >
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/HOMELESS%20FORM%20SIDE%201.pdf"
                target="_blank"
                >SEXUAL OFFENDER NO-FIXED ADDRESS SUPPLEMENT - PG 1</a
              >
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/HOMELESS%20FORM%20SIDE%202.pdf"
                target="_blank"
                >SEXUAL OFFENDER NO-FIXED ADDRESS SUPPLEMENT - PG 2</a
              >
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/SEX%20OFF%20ADD%20CHG%20FORM%20012220.pdf"
                target="_blank"
                >SEX OFFENDER 3-PAGE VERIFICATION - CHANGE FORM</a
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

.bcs-expansion-content {
  color: black;
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "wcrd_reg_frms",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
